/* eslint-disable no-unused-vars */

import { Tab, Tabs, ThemeProvider, createTheme, Box } from '@mui/material';
import 'assets/KatalogTabSwitch.css';
import { capitalCase } from 'change-case';

type KatalogTabSwitchInterface = {
  tabs?: any;
  tabsSelected?: string;
  onChange?: (params?: any) => void;
  fullwidth?: boolean;
};

const KatalogTabSwitch = ({ tabs, tabsSelected, onChange, fullwidth }: KatalogTabSwitchInterface) => {
  const fontColorEnable = 'white !important';
  const fontColorDisable = '#0045FF !important';

  const customTabs = createTheme({
    components: {
      MuiTabs: {
        styleOverrides: {
          flexContainer: {
            justifyContent: 'center'
          },
          indicator: {
            backgroundColor: '#0045ff',
            height: '100%',
            zIndex: 1,
            borderRadius: '25px',
            transitionDuration: '100ms'
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            zIndex: 2,
            width: '100%',
            fontWeight: 'bold'
          }
        }
      }
    }
  });

  const handleClickButton = async (e, value) => {
    onChange(value);
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <ThemeProvider theme={customTabs}>
        <Tabs
          value={tabsSelected}
          scrollButtons="auto"
          variant="scrollable"
          allowScrollButtonsMobile
          onChange={async (e, value) => await handleClickButton(e, value)}
          sx={{
            backgroundColor: '#e6edff',
            borderRadius: 20,
            width: fullwidth ? '100%' : 'initial'
          }}
        >
          {tabs.map((tab) => (
            <Tab
              className="switch_button"
              sx={{
                color: tabsSelected === tab.value ? fontColorEnable : fontColorDisable
              }}
              key={tab.value}
              value={tab.value}
              label={capitalCase(tab.value)}
            />
          ))}
        </Tabs>
      </ThemeProvider>
    </Box>
  );
};

export default KatalogTabSwitch;
